import * as theme from '../../theme';
import Heading from '../../components/Heading';
import { useNavigate } from "react-router";
import MiniScansList from '../../components/MiniScansList';

export default function MiniScans() {
  const navigate = useNavigate();

  function navigateBack() {
    navigate(`/dashboard`);
  }

  return (
    <div style={{ ...theme.Container.flexColumn.flexColumnContainer, ...theme.Container.center800 }}>
      <div style={theme.Container.flexColumn}>
        <Heading
          title={`Mini Scans`}
          onClick={() => navigateBack()}
        />
        <div style={{ ...theme.SubText2, paddingLeft: 10, paddingRight: 10 }}>
          Mini Scans are included within the Root Cause scan and report. You will not receive a separate report for Mini Scans. Mini scans are not required. If any show up in the Root Cause scan, we will scan those regardless. This is just if you specifically want us to include this in the Root Cause scan.
        </div>
      </div>
      <div style={theme.Container.fullMax}>
        <div style={theme.Container.flexOne}>
          <MiniScansList />
        </div>
      </div>
    </div>
  );
}